<template>
  <div class="ugo-form-field">
  <FormViewItem v-if="as_view" :label="label" :required="!!required">
    <span class="ugo-form-view-text" :class="{ 'ugo-form-view-empty': !viewDisplayText }">{{ viewDisplayText || '—' }}</span>
  </FormViewItem>
  <FormItem v-else :label="label" :required="!!required" :prop="fkey">
    <template v-if="editable">
    <Select
      :value="strValue"
      @input="handleInput"
      transfer
      clearable
      filterable
      :multiple="config.multiple"
      placeholder="请选择或输入文字"
      >
          <Option
          :label="o.name" v-for="o in options" :key="o.key" :value="o.key" :disabled="!editable"
          :border="config.border">
            <Icon v-if="o.icon" :type="o.icon"></Icon>
            <span>{{o.name}}</span>
        </Option>
    </Select>

    </template>
    <template v-else>
      <div>{{viewDisplayText || '—'}}</div>
    </template>
 </FormItem>
  </div>
</template>

<script>
import composedMixin from '../mixins/composed';
import defaultValueMixin from '../mixins/default-value';
import valueDefMixin from '../mixins/value-def';
import asViewMixin from '../mixins/as-view';
export default {
  mixins: [composedMixin, defaultValueMixin, valueDefMixin, asViewMixin],
  valueDefControl: 'UgoMultiSelect',
  cname: '下拉多选框',
  corder: 36,
  icon: 'xialaliebiao',
  properties: [{
    label: '选项',
    key: 'options',
    control: 'SelectOption',
  }, {
    label: '简易选项',
    key: 'simple',
    control: 'Check',
  },  {
    label: 'URL',
    key: 'url',
    control: 'Text',
  }],
  props: ['fkey', 'config', 'value', 'editable', 'label','required'],
  initModel(e) {
    if (!e.config) {
      e.config = {
        border: false,
        simple: true,
        options: ['选项1', '选项2'],
        url: '',
      };
    } else {
      e.config = {
        options: e.config.options || ['选项1', '选项2'],
        url: e.config.url,
        border: e.config.border,
        simple: e.config.simple,
        multiple: e.config.multiple,
      };
    }
  },
  data() {
    return {
      items: [],
    };
  },

  computed: {
    strValue() {
      if (this.multiple) {
        return Array.isArray(this.value)?this.value.map((v)=>v.toString()):[];
      } else {
        if (this.value !== undefined) {
          const value = this.value || 0;
          return value.toString();
        }
      }
    },
    viewDisplayText() {
      if (this.multiple) {
        if (!Array.isArray(this.value) || this.value.length === 0) {
          return '';
        }
        return this.value
          .map((v) => (this.options.find((t) => t.key == v) || {}).name)
          .filter(Boolean)
          .join('、');
      }
      return (this.options.find((t)=>t.key==this.value) || {}).name;
    },
    options() {
      let options = this.config.options;
      if (Array.isArray(options)) {
        if (options && typeof options[0] != 'object') {
          options = options.map((v, i)=>({
            key: i,
            name: v,
          }));
        }
      }
      if (this.config && this.config.simple) {
        options = (options || []).map((v)=>({key: v.name, name: v.name}));
      }
      return options;
    },
  },
  methods: {
    getValueDef() {
      return this.valueDefCheckArray();
    },
    handleInput(e) {
      this.$emit('input', e);
    },

  },
};
</script>

  <style lang="less">
  .l-full{
    position: relative;
    height:100%;
    width:100%;
  }
  </style>
